module.exports = __webpack_public_path__ + "static/media/toolbar-vertical.160e1149.svg";